/**
 * Die Sperre vor dem Einstellungsdialog der App.
 *
 * **Auftrag des Nutzers, 2026-09-13:** In den iPad-Einstellungen lässt sich ein Passwort
 * hinterlegen. Ist eines gesetzt, öffnet die App ihren Einstellungsdialog erst danach.
 *
 * ⚠️ **Was sie leistet und was nicht.** Das Passwort steht in den iPad-Einstellungen im
 * Klartext — wer dorthin gelangt, liest und ändert es. Sie hält den neugierigen Prüfer ab,
 * nicht den entschlossenen. Gedacht ist sie für den **geführten Zugriff**, wo genau dieser Weg
 * versperrt ist; dort ist sie die einzige Tür, die es noch zu schliessen gibt.
 *
 * ⚠️ **Kein Zählwerk, keine Sperrzeit.** Ein Prüfer, der sich mitten in einer Prüfung
 * aussperrt, ist der teurere Fehler — und ein Angreifer, der ohnehin an die iPad-Einstellungen
 * kommt, bräuchte das Raten gar nicht erst.
 */

/** Ob der Dialog gerade zu ist. */
export function istGesperrt({ passwort, frei }: { passwort: string; frei: boolean }): boolean {
  return passwort.trim() !== '' && !frei;
}

/**
 * Passt die Eingabe?
 *
 * ⚠️ **An den Rändern wird geschnitten**, auf beiden Seiten. Das Feld in den iPad-Einstellungen
 * fängt beim Tippen leicht ein Leerzeichen ein; ein Prüfer, der deshalb vor einer verschlossenen
 * Tür steht, ruft niemanden an — er hält die App für kaputt.
 */
export function passtPasswort(eingabe: string, erwartet: string): boolean {
  const sauber = erwartet.trim();
  return sauber !== '' && eingabe.trim() === sauber;
}
